import { render, staticRenderFns } from "./BodyPoint.vue?vue&type=template&id=883786ac&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./BodyPoint.vue?vue&type=script&lang=ts"
export * from "./BodyPoint.vue?vue&type=script&lang=ts"
import style0 from "./BodyPoint.vue?vue&type=style&index=0&id=883786ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883786ac",
  null
  
)

export default component.exports